import videoPlayer from './components/videoPlayer';
import Sliders from './components/sliders';
import Counters from './components/counters';
import Cookies from './components/cookies';
import ExitPopup from './components/exitPopup';
import SingleProduct from './components/singleProduct';
import Basket from './components/basket';
import DataLayer from './components/datalayer';

document.addEventListener('DOMContentLoaded',function() {

    videoPlayer();
    Sliders();
    Counters();
    Cookies();
    ExitPopup();
    SingleProduct();
    Basket();
    DataLayer();

    const burgerOpen = document.getElementsByClassName('header__right-icons-burger')[0];
    const burgerClose = document.getElementsByClassName('burger-menu__top-close')[0];
    const burgerWrapper = document.getElementsByClassName('burger-menu')[0];

    if(burgerOpen) {
        burgerOpen.addEventListener('click', function() {
            if(burgerWrapper) {
                if(burgerWrapper.classList.contains('show')) {
                    burgerWrapper.classList.remove('show');
                } else {
                    burgerWrapper.classList.add('show');
                }
            }
        })
        burgerClose.addEventListener('click', function() {
            if(burgerWrapper) {
                if(burgerWrapper.classList.contains('show')) {
                    burgerWrapper.classList.remove('show');
                } else {
                    burgerWrapper.classList.add('show');
                }
            }
        })
    }

    const diseasesContents = document.getElementsByClassName('diseases-content-js');
    const diseasesMenu     = document.getElementsByClassName('diseases-menu-js');

    if(diseasesContents && diseasesMenu) {
        for(var i = 0; i < diseasesMenu.length; i++) {
            diseasesMenu[i].addEventListener('click',function() {

                let clickedData = this.dataset.name;

                for(var i = 0; i < diseasesMenu.length; i++) {
                    diseasesMenu[i].classList.remove('active');
                }
                
                this.classList.add('active')

                for(var k = 0; k < diseasesContents.length; k++) {
                    diseasesContents[k].classList.remove('active');
                    if(diseasesContents[k].dataset.name === clickedData) {
                        diseasesContents[k].classList.add('active');
                    }
                }
            })
        }
    }

    const allFaqItems = document.getElementsByClassName('support__faq-items-item-title');

    if(allFaqItems) {
        for(var i = 0; i < allFaqItems.length; i++) {
            allFaqItems[i].addEventListener('click', function() {

                if(this.parentNode.classList.contains('active')) {
                    this.parentNode.classList.remove('active');
                } else {

                    for(var j = 0; j < allFaqItems.length; j++) {
                        allFaqItems[j].parentNode.classList.remove('active');
                    }

                    this.parentNode.classList.add('active');
                }

            })
        }
    }


    const webinarPopup = document.getElementsByClassName('webinar-popup')[0];
    const openPopup    = document.getElementsByClassName('js-open-popup')[0];
    const submitForm   = document.querySelector('.webinar-popup__wrapper-form-submit input');
    const closePopup   = document.getElementsByClassName('webinar-popup__wrapper-close')[0];

    if(webinarPopup) {
        webinarPopup.addEventListener('click', function(el) {
            if(el.target.classList.contains('webinar-popup')) {
                this.classList.remove('active');
            }
        })
    }

    if(openPopup) {
        openPopup.addEventListener('click', function() {
            if(webinarPopup) {
                webinarPopup.classList.add('active');
            }
        })
    }

    if(submitForm) {
        submitForm.addEventListener('click', function() {
            if(webinarPopup) {
                setTimeout(() => {
                        webinarPopup.classList.add('active');
                }, 1000);
            }
        })
    }

    if(closePopup) {
        closePopup.addEventListener('click', function() {
            if(webinarPopup) {
                webinarPopup.classList.remove('active');
            }
        })
    }

})